import { prop } from 'ramda';

import { usePageSelector } from '@core/js/store/hooks';

export const useSetDefaultFontSize = () => {
    const storageFontSize = localStorage.getItem('fontSize');
    const htmlDefaultFontSize = window.Playtech?.Variables?.defaultFontSize;
    const pageRootClassNames = usePageSelector(prop('rootClassNames'));

    const pageClassSizeOverride = pageRootClassNames.match(/override-font-size-([0-9]+)/i)?.[1];
    const pageClassFontValue = pageClassSizeOverride ? `${pageClassSizeOverride}px` : null;

    // Will take 16px from CSS when all three are empty.
    const newFontSizeValue = pageClassFontValue || htmlDefaultFontSize || storageFontSize;

    if (newFontSizeValue) {
        document.documentElement.style.fontSize = newFontSizeValue;
    }
};
